import * as Yup from "yup";
import registrationFormModel from "../pages/login/registration/registrationFormModel";
import yupPassword from "yup-password";

// eslint-disable-next-line max-params
export const setLocalCredentials = (email, token, refreshToken, jwtAuthExpiration) => {
	localStorage.setItem("user", JSON.stringify({
		email,
		refreshToken,
		token
	}));
	localStorage.setItem("lastLoginTime", new Date().getTime());
	localStorage.setItem("jwtAuthExpiration", parseInt(jwtAuthExpiration, 10) * 1000);
};

export const logoutUser = () => {
	localStorage.removeItem("user");
	localStorage.removeItem("jwtAuthExpiration");
	localStorage.removeItem("lastLoginTime");
};

export const decodeEntity = (inputStr) => {
	const textarea = document.createElement("textarea");
	textarea.innerHTML = inputStr;
	return textarea.value;
};

// eslint-disable-next-line no-extra-parens
export const userCanRegister = (user) => user === false || (user !== null && typeof user?.attendeeId !== "undefined");

// User Object and Capability
export const facilitatorCan = (user, capability) => user !== null &&
	typeof user.additionalCapabilities !== "undefined" &&
	user.additionalCapabilities.indexOf(capability) > -1;

export const googleAPIKey = () => process.env.REACT_APP_GMAPS_API;

export const isWpAdmin = () => !!window.wpApiSettings;

export const passwordMinLength = 8;

/**
 * Get Yup Password Validation Schema
 *
 * @returns object
 */
export const passwordValidationSchema = () => {
	yupPassword(Yup);

	const {
		formField: {
			password,
			passwordConfirm
		}
	} = registrationFormModel;

	return {
		[password.name]: Yup.string().
			password().
			min(passwordMinLength, `${password.requiredErrorMsg}`).
			required(`${password.requiredErrorMsg}`),
		[passwordConfirm.name]: Yup.string().oneOf([Yup.ref(password.name), null], passwordConfirm.invalidErrorMsg).
			required(`${passwordConfirm.requiredErrorMsg}`)
	};
};
